/**
 *
 * @author fuyg
 * @date  2020-05-20
 */

import React, { ReactElement } from 'react'
import { Carousel } from 'antd'
import styles from './Banner.module.scss'
import Slogan from './Slogan'
import StockMarket from './StockMarket'

function Banner(): ReactElement {
  return (
    <Carousel>
      <div
        className={`${styles.container} ${styles['hard-ware']} ${styles['banner-bg']}`}
      >
        <div className={styles.layer}></div>
        <div className={styles.center}>
          <Slogan />
          <div className={styles.stock}>
            <StockMarket />
          </div>
        </div>
      </div>
    </Carousel>
  )
}

export default Banner
